// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1HLfE","rootCenter":"LoadMoreObserver_rootCenter__M_eev","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__BVBob"};